<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="type">
          <el-select v-model="listQuery.type" placeholder="请选择余额类型" clearable @keyup.enter.native="SearchData">
            <el-option label="充值" :value="1"></el-option>
            <el-option label="支出" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="listQuery.time" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" @change="SearchData">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button type="success" @click="goBack()">返回用户</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column align="center" prop="nickname" label="用户姓名"> </el-table-column>
      <el-table-column align="center" prop="type" label="余额类型">
        <template slot-scope="{ row }">
          <el-tag v-if="row.type==1" type="success">入账</el-tag>
          <el-tag v-else type="danger">出账</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="title" label="操作描述"> </el-table-column>
      <el-table-column align="center" prop="money" label="金额"> </el-table-column>
      <el-table-column align="center" prop="order_no" label="订单号 "> </el-table-column>
      <el-table-column align="center" prop="create_time" label="操作时间 "> </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
  </div>
</template>

<script>
import api from '@/api/usermoney' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
export default {
  name: 'Money',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {},
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created() {
    this.listQuery.user_id = this.$route.query.id
    this.loadData()
  },
  methods: {
    // 条件过滤查询
    SearchData() {
      this.listQuery.user_id = this.$route.query.id
      this.listQuery.page = 1
      this.loadData()
    },
    goBack() {
      this.$router.push({ path: '/user/user' })
    }
  }
}
</script>
